import { StatusModel } from "./StatusModel";

/**
 * * Модель задачи в поиске
 */
export class TaskInSearchModel {
  /**ID задачи */
  Id!: number;
  /**Название задачи */
  Name!: string;
  /**Код задачи */
  Code!: string;
  /**Статус задачи */
  Status!: StatusModel;

  constructor(obj?: Partial<TaskInSearchModel>) {
    Object.assign(this, obj);
  }
}
